import React from 'react';
import Chart from 'react-apexcharts';

// Professional color palette
const COLORS = [
  "#2196F3", // Primary blue
  "#4CAF50", // Success green
  "#FFC107", // Warning amber
  "#F44336", // Error red
  "#9C27B0", // Purple
  "#00BCD4", // Cyan
  "#FF9800", // Orange
  "#607D8B", // Blue grey
];

const BarGraph = ({ data = [], departments = [] }) => {
  // Calculate percentages for each department in each region
  const processedData = data.map(item => {
    const total = departments.reduce((sum, dept) => sum + (item[dept] || 0), 0);
    return departments.reduce((acc, dept) => {
      acc[dept] = total > 0 ? ((item[dept] || 0) / total) * 100 : 0;
      return acc;
    }, { name: item.name });
  });

  const series = departments.map(dept => ({
    name: dept.replace(/_/g, ' '),
    data: processedData.map(item => item[dept] || 0)
  }));

  const options = {
    chart: {
      type: 'bar',
      stacked: true,
      stackType: '100%',
      toolbar: {
        show: false
      },
      fontFamily: 'Inter, sans-serif',
      background: 'transparent'
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 6,
        columnWidth: '40%',
        dataLabels: {
          total: {
            enabled: true,
            style: {
              fontSize: '12px',
              fontWeight: 600
            }
          }
        }
      },
    },
    colors: COLORS,
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        if (val <= 0) return '';
        return val.toFixed(1) + '%';
      },
      style: {
        fontSize: '11px',
        fontWeight: 600,
        colors: ['#fff']
      }
    },
    stroke: {
      show: true,
      width: 1,
      colors: ['#fff']
    },
    xaxis: {
      categories: processedData.map(item => (item.name || '').replace(/_/g, ' ')),
      labels: {
        style: {
          fontSize: '11px',
          fontWeight: 500,
        },
        rotate: -45,
        trim: true,
        maxHeight: 50
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      }
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '11px',
          fontWeight: 500,
        },
        formatter: function (val) {
          return val.toFixed(0) + '%';
        }
      }
    },
    grid: {
      show: true,
      borderColor: '#E2E8F0',
      strokeDashArray: 5,
      xaxis: {
        lines: {
          show: false
        }
      },
      yaxis: {
        lines: {
          show: true
        }
      },
      padding: {
        top: 0,
        right: 10,
        bottom: 0,
        left: 10
      }
    },
    legend: {
      show: true,
      position: 'bottom',
      horizontalAlign: 'center',
      floating: false,
      fontSize: '11px',
      fontFamily: 'Inter, sans-serif',
      fontWeight: 400,
      markers: {
        width: 8,
        height: 8,
        strokeWidth: 0,
        strokeColor: '#fff',
        radius: 12,
        offsetX: 0,
        offsetY: 0
      },
      itemMargin: {
        horizontal: 8,
        vertical: 5
      }
    },
    tooltip: {
      theme: 'light',
      style: {
        fontSize: '11px',
        fontFamily: 'Inter, sans-serif'
      },
      y: {
        formatter: function(value) {
          if (value <= 0) return '0%';
          return value.toFixed(1) + '%';
        }
      }
    },
    responsive: [{
      breakpoint: 480,
      options: {
        legend: {
          position: 'bottom',
          offsetX: -10,
          offsetY: 0
        }
      }
    }]
  };

  return (
    <div style={{ width: '100%', height: '300px', maxHeight: '100%' }}>
      <Chart
        options={options}
        series={series}
        type="bar"
        height="100%"
        width="100%"
      />
    </div>
  );
};

export default BarGraph;
